module.exports = __webpack_public_path__ + "media/bootstrap-icons/folder-plus-75254dbc.svg";